<template>
  <ak-dropdown
    aria-role="list"
    position-x="right"
    position-y="bottom"
    size="big"
  >
    <template #trigger>
      <ak-button color="transparent" size="small" circle>
        <ak-icon type="more-vertical" />
      </ak-button>
    </template>
    <ak-dropdown-item @click="openSettings"> Settings </ak-dropdown-item>
    <ak-dropdown-item v-if="isFolder" @click="addSubFolder">
      Add Sub Folder
    </ak-dropdown-item>
    <ak-dropdown-item v-if="isFolder" @click="addProject">
      Add Project
    </ak-dropdown-item>
    <ak-dropdown-item
      v-if="isProject && isOwnAccount()"
      @click="toggleFavorite"
    >
      {{ isFavorite ? 'Remove Favorite' : 'Favorite' }}
    </ak-dropdown-item>
    <ak-dropdown-item class="warning-color-item" @click="toggleArchived">
      {{ item.archived ? 'Unarchive' : 'Archive' }}
    </ak-dropdown-item>
    <ak-dropdown-item class="danger-color-item" @click="deleteItem">
      Delete
    </ak-dropdown-item>
    <ak-dropdown-item v-if="isAgency" separator />
    <ak-dropdown-item v-if="isAgency" class="flex" @click="toggleHidden">
      {{ item.hidden ? 'Unset Agency Only' : 'Set Agency Only' }}
      <ak-tooltip placement="right" class="ml-tiny">
        <template #trigger>
          <ak-icon type="android-alert" />
        </template>
        <span class="text-small">
          {{
            item.hidden
              ? 'Only Agency Users or above can currently see this Campaign'
              : 'Only Agency Users or above will be able to see this Campaign'
          }}
        </span>
      </ak-tooltip>
    </ak-dropdown-item>
    <ak-dropdown-item v-if="isAgency" class="flex" @click="toggleActivity">
      {{
        item.agencyActivity ? 'Unset Natives Activity' : 'Set Natives Activity'
      }}
      <ak-tooltip placement="right" class="ml-tiny">
        <template #trigger>
          <ak-icon type="android-alert" />
        </template>
        <span class="text-small">
          {{
            item.agencyActivity
              ? 'Currently set as a campaign run by Natives'
              : 'Set as a campaign run by Natives'
          }}
        </span>
      </ak-tooltip>
    </ak-dropdown-item>
  </ak-dropdown>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'
import Dropdown from '@akerolabs/akero-vue/src/components/dropdown/Dropdown.vue'
import DropdownItem from '@akerolabs/akero-vue/src/components/dropdown/DropdownItem.vue'
import Tooltip from '@akerolabs/akero-vue/src/components/tooltip/Tooltip.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import { display } from '../utils'
export default defineComponent({
  name: 'ItemDropdown',
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [Tooltip.name]: Tooltip,
    [Icon.name]: Icon,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: undefined,
    },
    isFavorite: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'toggleArchived',
    'toggleHidden',
    'toggleFavorite',
    'toggleActivity',
    'delete',
    'settings',
    'addSubFolder',
    'addProject',
  ],
  setup(props, { emit }) {
    const isOwnAccount = inject('isOwnAccount')

    const isFolder = computed(() => {
      if (props.type === 'folder') return true
      return false
    })

    const isProject = computed(() => {
      if (props.type === 'project') return true
      return false
    })

    const isAgency = computed(() => {
      return display('show', 'developer,superadmin,agencyadmin,agencyuser')
    })

    const toggleArchived = () => {
      emit('toggleArchived')
    }

    const toggleHidden = () => {
      emit('toggleHidden')
    }

    const toggleFavorite = () => {
      emit('toggleFavorite')
    }

    const toggleActivity = () => {
      emit('toggleActivity')
    }

    const deleteItem = () => {
      emit('delete')
    }

    const openSettings = () => {
      emit('settings')
    }

    const addSubFolder = () => {
      emit('addSubFolder')
    }

    const addProject = () => {
      emit('addProject')
    }

    return {
      isFolder,
      isProject,
      isAgency,
      isOwnAccount,
      toggleArchived,
      toggleHidden,
      toggleFavorite,
      toggleActivity,
      deleteItem,
      openSettings,
      addSubFolder,
      addProject,
    }
  },
})
</script>

<style lang="scss">
@import '@akerolabs/akero-vue/src/scss/_settings.scss';
.warning-color-item {
  color: $color-warning !important;
  &:hover {
    color: $color-warning !important;
  }
}

.danger-color-item {
  color: $color-danger !important;
  &:hover {
    color: $color-danger !important;
  }
}
</style>
